export const LOGIN = "LOGIN";
export const AUTH_LOADING = "AUTH_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGOUT = "LOGOUT";
export const RESET_AUTH = "RESET_AUTH";
export const GAUTH_CREDS = "GAUTH_CREDS";

export const SET_WS_PARAMS = "SET_WS_PARAMS";

export const FETCH_CLIENT_LIST = "FETCH_CLIENT_LIST";
export const CLIENT_LOADING = "CLIENT_LOADING";
export const CLIENT_LIST_LOADING = "CLIENT_LIST_LOADING";
export const CLIENT_PROFILE_LOADING = "CLIENT_PROFILE_LOADING";
export const CLIENT_ERROR = "CLIENT_ERROR";
export const CLIENT_APP_DATA_LOADING = "CLIENT_APP_DATA_LOADING";
export const SET_CLIENT_PROFILE = "SET_CLIENT_PROFILE";
export const CLEAR_CLIENT_PROFILE = "CLEAR_CLIENT_PROFILE";
export const SET_SELECTED_NOTE_META = "SET_SELECTED_NOTE_META";
export const CLEAR_SELECTED_NOTE_META = "CLEAR_SELECTED_NOTE_META";
export const SET_VERIFYING_NSP = "SET_VERIFYING_NSP";

export const CHAT_CLIENT_LIST_LOADING = "CHAT_CLIENT_LIST_LOADING";
export const CHAT_CLIENT_LIST = "CHAT_CLIENT_LIST";
export const SET_CLIENT_CHAT = "SET_CLIENT_CHAT";
export const UPDATE_CLIENT_CHAT_ROOM_UNREAD_COUNT =
  "UPDATE_CLIENT_CHAT_ROOM_UNREAD_COUNT";

export const RESET_CLIENTS_LIST = "RESET_CLIENT_LIST";

export const FETCH_SESSIONS_LIST = "FETCH_SESSIONS_LIST";
export const SESSIONS_LIST_LOADING = "SESSIONS_LIST_LOADING";

export const CANCEL_UPCOMING_SESSION = "CANCEL_UPCOMING_SESSION";
export const CANCELLATION_REASON = "CANCELLATION_REASON";
export const SESSION_COUNT = "SESSION_COUNT";
export const UPDATE_SESSION_OBJ = "UPDATE_SESSION_OBJ";
export const LOADING_SESSION_ACTIONS = "LOADING_SESSION_ACTIONS";

export const FETCH_PRESCRIPTIONS = "FETCH_PRESCRIPTIONS";
export const SET_PRESCRIPTION_UPDATE_TRIGGER =
  "SET_PRESCRIPTION_UPDATE_TRIGGER";

export const SHOW_ADD_PRESCRIPTION_MODAL = "SHOW_ADD_PRESCRIPTION_MODAL";

export const GET_CLIENT_TOOLS_SUCCESS = "GET_CLIENT_TOOLS_SUCCESS";
export const GET_CLIENT_TOOLS_FAILURE = "GET_CLIENT_TOOLS_FAILURE";

export const GET_TIMELINE_TOOLS_SUCCESS = "GET_TIMELINE_TOOLS_SUCCESS";
export const CLEAR_TIMELINE_TOOLS_SUCCESS = "CLEAR_TIMELINE_TOOLS_SUCCESS";
export const GET_TIMELINE_TOOLS_FAILURE = "GET_TIMELINE_TOOLS_FAILURE";

export const ASSIGN_TOOL_SUCCESS = "ASSIGN_TOOL_SUCCESS";
export const ASSIGN_TOOL_FAILURE = "ASSIGN_TOOL_FAILURE";
export const CLEAR_VIEW_TOOL = "CLEAR_VIEW_TOOL";

export const VIEW_TOOL_SUCCESS = "VIEW_TOOL_SUCCESS";
export const VIEW_TOOLS_FAILURE = "VIEW_TOOLS_FAILURE";

export const SEND_REMINDER_SUCCESS = "SEND_REMINDER_SUCCESS";
export const SEND_REMINDER_FAILURE = "SEND_REMINDER_FAILURE";

export const ASSESSMENT_FOR_PSYCHIATRIST_SUCCESS =
  "ASSESSMENT_FOR_PSYCHIATRIST_SUCCESS";
export const ASSESSMENT_FOR_PSYCHIATRIST_FAILURE =
  "ASSESSMENT_FOR_PSYCHIATRIST_FAILURE";

export const PRO_ASSESSMENT_SUCCESS = "PRO_ASSESSMENT_SUCCESS";
export const PRO_ASSESSMENT_FAILURE = "PRO_ASSESSMENT_FAILURE";

export const COMPLETED_ASSESSMENTS_SUCCESS = "COMPLETED_ASSESSMENTS_SUCCESS";
export const COMPLETED_ASSESSMENTS_FAILURE = "COMPLETED_ASSESSMENTS_FAILURE";

export const ASSIGNED_ASSESSMENTS_SUCCESS = "ASSIGNED_ASSESSMENTS_SUCCESS";
export const ASSIGNED_ASSESSMENTS_FAILURE = "ASSIGNED_ASSESSMENTS_FAILURE";

export const UNASSIGNED_ASSESSMENTS_SUCCESS = "UNASSIGNED_ASSESSMENTS_SUCCESS";
export const UNASSIGNED_ASSESSMENTS_FAILURE = "UNASSIGNED_ASSESSMENTS_FAILURE";

export const ASSIGN_ASSESSMENT_SUCCESS = "ASSIGN_ASSESSMENT_SUCCESS";
export const ASSIGN_ASSESSMENT_FAILURE = "ASSIGN_ASSESSMENT_FAILURE";

export const UNASSIGN_ASSESSMENT_SUCCESS = "UNASSIGN_ASSESSMENT_SUCCESS";
export const UNASSIGN_ASSESSMENT_FAILURE = "UNASSIGN_ASSESSMENT_FAILURE";

export const ASSESSMENT_DETAIL_SUCCESS = "ASSESSMENT_DETAIL_SUCCESS";
export const ASSESSMENT_DETAIL_FAILURE = "ASSESSMENT_DETAIL_FAILURE";

export const ASSESSMENT_RESULT_SUCCESS = "ASSESSMENT_RESULT_SUCCESS";
export const ASSESSMENT_RESULT_FAILURE = "ASSESSMENT_RESULT_FAILURE";

export const SEND_ASSESSMENT_REMINDER_SUCCESS =
  "SEND_ASSESSMENT_REMINDER_SUCCESS";

export const RESET_ASSESSMENTS = "RESET_ASSESSMENTS";

export const FETCH_CHAT_LIST = "FETCH_CHAT_LIST";
export const CHATLIST_LOADING = "CHATLIST_LOADING";
export const SAVE_DECRYPTION_KEY = "SAVE_DECRYPTION_KEY";
export const TOGGLE_CHAT_BLOCK = "TOGGLE_CHAT_BLOCK";
export const SET_MOBILE_UNREAD_CHAT_COUNT = "SET_MOBILE_UNREAD_CHAT_COUNT";
export const SET_NEW_CHAT_UNREAD_ROOM_IDS = "SET_NEW_CHAT_UNREAD_ROOM_IDS";
export const UPSERT_NEW_CHAT_UNREAD_ROOM_ID = "UPSERT_NEW_CHAT_UNREAD_ROOM_ID";
export const REMOVE_NEW_CHAT_UNREAD_ROOM_ID = "REMOVE_NEW_CHAT_UNREAD_ROOM_ID";
export const CLEAR_NEW_CHAT_UNREAD_ROOM_IDS = "CLEAR_NEW_CHAT_UNREAD_ROOM_IDS";

export const FETCH_PROVIDER_PROFILE = "FETCH_PROVIDER_PROFILE";
export const FETCH_PROVIDER_SCHEDULE = "FETCH_PROVIDER_SCHEDULE";
export const PROVIDER_PROFILE_LOADING = "PROVIDER_PROFILE_LOADING";
export const PROVIDER_MOBILE_VERIFIED = "PROVIDER_MOBILE_VERIFIED";
export const ADD_LOCAL_PROVIDER_PROFILE = "ADD_LOCAL_PROVIDER_PROFILE"; //todo to be revisited - ds
export const UPDATE_LOCAL_PROVIDER_PROFILE = "UPDATE_LOCAL_PROVIDER_PROFILE";
export const RESET_LOCAL_PROVIDER_PROFILE = "RESET_LOCAL_PROVIDER_PROFILE";

export const SAVE_CLIENT_ANALYTICS = "SAVE_CLIENT_ANALYTICS";
export const SAVE_SESSION_ANALYTICS = "SAVE_SESSIONS_ANALYTICS";
export const SAVE_FEEDBACK_ANALYTICS = "SAVE_FEEDBACK_ANALYTICS";
export const SAVE_REPEAT_RATIO_ANALYTICS = "SAVE_REPEAT_RATIO_ANALYTICS";
export const ANALYTICS_ERROR = "ANALYTICS_ERROR";

export const SAVE_NEW_TEMPLATE_SUCCESS = "SAVE_NEW_TEMPLATE_SUCCESS";
export const SAVE_NEW_TEMPLATE_FAILURE = "SAVE_NEW_TEMPLATE_FAILURE";

export const SHORTCUT_LISTING_SUCCESS = "SHORTCUT_LISTING_SUCCESS";
export const SHORTCUT_SEARCH_SUCCESS = "SHORTCUT_SEARCH_SUCCESS";
export const CHANGE_MODE_SUCCESS = "CHANGE_MODE_SUCCESS";
export const SESSION_RESCHEDULE_SUCCESS = "SESSION_RESCHEDULE_SUCCESS";
export const AUTOMATED_CALL_SUCCESS = "AUTOMATED_CALL_SUCCESS";

export const ADD_TOAST = "ADD_TOAST";
export const REMOVE_TOAST = "REMOVE_TOAST";
export const REMOVE_ALL_TOAST = "REMOVE_ALL_TOAST";
export const GET_TOOL_TYPE_SUCCESS = "GET_TOOL_TYPE_SUCCESS";
export const GET_TOOL_TYPE_FAILURE = "GET_TOOL_TYPE_FAILURE";
export const ALL_TOOL_SUCCESS = "ALL_TOOL_SUCCESS";
export const ALL_TOOL_FAILURE = "ALL_TOOL_FAILURE";
export const FIRST_SESSION = "FIRST_SESSION";
export const SET_TREATMENT_PLAN_DISABLED_STATUS =
  "SET_TREATMENT_PLAN_DISABLED_STATUS";
export const SET_TREATMENT_PLAN_SEND_STATUS = "SET_TREATMENT_PLAN_SEND_STATUS";
export const CUSTOM_JOURNAL_QUESTION_SUCCESS =
  "CUSTOM_JOURNAL_QUESTION_SUCCESS";
export const CUSTOM_JOURNAL_QUESTION_FAILURE =
  "CUSTOM_JOURNAL_QUESTION_FAILURE";

export const LOAD_SESSION_ON_CLIENTS = "LOAD_SESSION_ON_CLIENTS";

export const BSE_RESET_DATA = "BSE_RESET_DATA";
export const BSE_SAVE_CLIENTS = "BSE_SAVE_CLIENTS";
export const BSE_ADD_TOOLS_TO_CART = "BSE_ADD_TOOLS_TO_CART";
export const BSE_SAVE_META_INFO = "BSE_SAVE_META_INFO";
export const BSE_SAVE_ADDED_TOOLS = "BSE_SAVE_ADDED_TOOLS";
export const SET_CUSTOM_TOOL_TEMPLATES = "SET_CUSTOM_TOOL_TEMPLATES";
export const SET_CUSTOM_TOOL_TYPE = "SET_CUSTOM_TOOL_TYPE";
export const SET_FILTER_CONCERNS = "SET_FILTER_CONCERNS";

export const SET_PRESCRIPTION_META = "SET_PRESCRIPTION_META";
export const LOADING_PRESCRIPTIONS_META = "LOADING_PRESCRIPTIONS_META";

export const SET_MEDICINES = "SET_MEDICINES";
export const SET_HAS_REFERRAL = "SET_HAS_REFERRAL";
export const SET_HAS_INVESTIGATION = "SET_HAS_INVESTIGATION";
export const SET_ADD_MEDICINE_SCREEN_VISIBLE =
  "SET_ADD_MEDICINE_SCREEN_VISIBLE";

export const SET_HAS_NEW_NOTIFICATION = "SET_HAS_NEW_NOTIFICATION";
export const SET_ARE_NOTIFICATIONS_PAUSED = "SET_ARE_NOTIFICATIONS_PAUSED";
export const SET_UNREAD_NOTIFICATIONS_COUNT = "SET_UNREAD_NOTIFICATIONS_COUNT";
export const SET_IS_LOADING_ROLES = "SET_IS_LOADING_ROLES";

export const ADD_PROVIDER_ROLES = "ADD_PROVIDER_ROLES";
export const SET_SELECTED_ROLE = "SET_SELECTED_ROLE";

export const NSP_TOUR = "NSP_TOUR";
export const DASHBOARD_TOUR = "DASHBOARD_TOUR";
export const CLIENT_TOUR = "CLIENT_TOUR";
export const BASE_WEEK_TOUR = "BASE_WEEK_TOUR";
export const SINGLE_DAY_TOUR = "SINGLE_DAY_TOUR";
export const SHOW_TOOLTIP = "SHOW_TOOLTIP";
export const NOTIFICATIONS_TOUR = "NOTIFICATIONS_TOUR";

// Analytics action types
export const GLOBAL_TIME_FILTER = "GLOBAL_TIME_FILTER";

export const CLIENT_SESSIONS = "CLIENT_SESSIONS";
export const CLIENT_SESSIONS_LOADING = "CLIENT_SESSIONS_LOADING";
export const CLIENT_SESSIONS_ERROR = "CLIENT_SESSIONS_ERROR";

export const CLIENT_FOLLOWUP = "CLIENT_FOLLOWUP";
export const CLIENT_FOLLOWUP_LOADING = "CLIENT_FOLLOWUP_LOADING";
export const CLIENT_FOLLOWUP_ERROR = "CLIENT_FOLLOWUP_ERROR";

export const AVERAGE_SESSIONS = "AVERAGE_SESSIONS";
export const AVERAGE_SESSIONS_LOADING = "AVERAGE_SESSIONS_LOADING";
export const AVERAGE_SESSIONS_ERROR = "AVERAGE_SESSIONS_ERROR";

export const SESSION_SUMMARY = "SESSION_SUMMARY";
export const SESSION_SUMMARY_LOADING = "SESSION_SUMMARY_LOADING";
export const SESSION_SUMMARY_ERROR = "SESSION_SUMMARY_ERROR";

export const DIAGNOSIS = "DIAGNOSIS";
export const DIAGNOSIS_LOADING = "DIAGNOSIS_LOADING";
export const DIAGNOSIS_ERROR = "DIAGNOSIS_ERROR";

export const TIME_UTILISATION_LOADING = "TIME_UTILISATION_LOADING";
export const TIME_UTILISATION = "TIME_UTILISATION";
export const TIME_UTILISATION_ERROR = "TIME_UTILISATION_ERROR";

export const OTHER_INFORMATION = "OTHER_INFORMATION";
export const OTHER_INFORMATION_LOADING = "OTHER_INFORMATION_LOADING";
export const OTHER_INFORMATION_ERROR = "OTHER_INFORMATION_ERROR";

export const UPDATE_BATCH_ACTION_STATUS = "UPDATE_BATCH_ACTION_STATUS";
export const RESET_BATCH_ACTION_STATUS = "RESET_BATCH_ACTION_STATUS";

// revamp things
export const MONTHLY_SCHEDULE = "MONTHLY_SCHEDULE";

export const SET_DASHBOARD_TITLE = "SET_DASHBOARD_TITLE";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const DAILY_SCHEDULE = "DAILY_SCHEDULE";
export const EDIT_DAILY_SCHEDULE = "EDIT_DAILY_SCHEDULE";
export const BASE_WEEK_SCHEDULE = "BASE_WEEK_SCHEDULE";
export const EDIT_BASE_WEEK_SCHEDULE = "EDIT_BASE_WEEK_SCHEDULE";
export const CLEAR_BASE_WEEK_SCHEDULE = "CLEAR_BASE_WEEK_SCHEDULE";

export const UPDATE_REMOTE_PROVIDER_PROFILE = "UPDATE_REMOTE_PROVIDER_PROFILE";

export const SHOW_LINKED_ACCOUNT_TOOLTIP = "SHOW_LINKED_ACCOUNT_TOOLTIP";

// informed consent
export const RESET_INFORMED_CONSENT_STATUS = "RESET_INFORMED_CONSENT_STATUS";

export const SET_CLIENT_INFORMED_CONSENT_STATUS =
  "SET_CLIENT_INFORMED_CONSENT_STATUS";

export const SET_PARTNER_INFORMED_CONSENT_STATUS =
  "SET_PARTNER_INFORMED_CONSENT_STATUS";

export const SET_IS_CLIENT_INFORMED_CONSENT_SHARED =
  "SET_IS_CLIENT_INFORMED_CONSENT_SHARED";

export const SET_IS_PARTNER_INFORMED_CONSENT_SHARED =
  "SET_IS_PARTNER_INFORMED_CONSENT_SHARED";

export const SET_LATEST_SESSION_NUMBER = "SET_LATEST_SESSION_NUMBER";

// mobile navigation
export const SHOW_TOP_NAV = "SHOW_TOP_NAV";
export const HIDE_TOP_NAV = "HIDE_TOP_NAV";
export const SHOW_BOTTOM_NAV = "SHOW_BOTTOM_NAV";
export const HIDE_BOTTOM_NAV = "HIDE_BOTTOM_NAV";

// feature flags
export const SET_FEATURE_FLAGS = "SET_FEATURE_FLAGS";
export const SET_AI_ENABLED_FEATURE_FLAG = "SET_AI_ENABLED_FEATURE_FLAG";
export const SET_AI_INTAKE_REPORT_FEATURE_FLAG =
  "SET_AI_INTAKE_REPORT_FEATURE_FLAG";
export const SET_AI_OFFLINE_RECORDING_FEATURE_FLAG =
  "SET_AI_OFFLINE_RECORDING_FEATURE_FLAG";
export const SET_AI_CHAT_FEATURE_FLAG = "SET_AI_CHAT_FEATURE_FLAG";
export const SET_TWA_MASTER_AI_CONSENT_FEATURE_FLAG =
  "SET_TWA_MASTER_AI_CONSENT_FEATURE_FLAG";
export const SET_AI_CHAT_FEATURE_FLAG_VERSION =
  "SET_AI_CHAT_FEATURE_FLAG_VERSION";
export const SET_CLIENT_PROFILE_TABS_LOADING =
  "SET_CLIENT_PROFILE_TABS_LOADING";
export const ADD_CLIENT_PROFILE_TABS = "ADD_CLIENT_PROFILE_TABS";

// CF Groups
export const FETCH_GROUPS_LIST = "FETCH_GROUPS_LIST";
export const RESET_GROUPS_LIST = "RESET_GROUPS_LIST";
export const GROUP_LIST_LOADING = "GROUP_LIST_LOADING";
export const GROUP_DETAILS = "GROUP_DETAILS";
export const RESET_GROUP_DETAILS = "RESET_GROUP_DETAILS";
export const GROUP_DETAILS_LOADING = "GROUP_DETAILS_LOADING";
export const GROUP_INDIVIDUAL_CUSTOMERS = "GROUP_INDIVIDUAL_CUSTOMERS";
export const RESET_INDIVIDUAL_CUSTOMERS = "RESET_INDIVIDUAL_CUSTOMERS";
export const GROUP_CUSTOMERS_LOADING = "GROUP_CUSTOMERS_LOADING";
export const IS_SOCIAL_GROUP = "IS_SOCIAL_GROUP";

// Country Codes
export const SET_COUNTRY_CODES = "SET_COUNTRY_CODES";

// TWA UI Updates
export const SAVE_TWA_AI_UI_EVENTS = "SAVE_TWA_AI_UI_EVENTS";
export const UPDATE_TWA_AI_UI_EVENT = "UPDATE_TWA_AI_UI_EVENT";

// AI Chat
export const SET_IS_CHAT_OPEN = "SET_IS_CHAT_OPEN";
export const SET_CHAT_VIEW = "SET_CHAT_VIEW";
export const SET_SELECTED_CONVERSATION = "SET_SELECTED_CONVERSATION";
export const SET_CONVERSATION_PAGINATION = "SET_CONVERSATION_PAGINATION";
export const SET_MESSAGES = "SET_MESSAGES";
export const UPDATE_MESSAGE_BY_ID = "UPDATE_MESSAGE_BY_ID";
export const SET_LIVE_CONTEXT = "SET_LIVE_CONTEXT";
export const CLEAR_CHAT_SESSION = "CLEAR_CHAT_SESSION";
export const SET_MESSAGE_SENT = "SET_MESSAGE_SENT";
export const SET_CALLOUT = "SET_CALLOUT";
export const SET_LAST_CHAT_CONVERSATION_ID = "SET_LAST_CHAT_CONVERSATION_ID";
